/**
 * Web Style Import
 *
 */

import './style/dnb-global-status.scss'
